import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Backdrop, Box, Button, CircularProgress, Grid, IconButton, Typography, useTheme } from "@mui/material";
import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from 'react-router-dom';
import CalendarIcon from '../../icons/CalendarIcon';
import CalendarNoEndIcon from '../../icons/CalendarNoEndIcon';
import DateTimeIcon from '../../icons/DateTimeIcon';
import ForwardIcon from '../../icons/ForwardIcon';
import OfficeIcon from '../../icons/OfficeIcon';
import PersonIcon from '../../icons/PersonIcon';
import PersonOutlinedIcon from '../../icons/PersonOutlinedIcon';
import TimeIcon from '../../icons/TimeIcon';
import { MessageContext } from "../../utils/MessageContext";
import { UserContext } from "../../utils/UserContext";
import { useAxios } from '../../utils/useAxios';
import DashboardDrawer from './DasboardDrawer';


export default function MobileSelection() {

    const theme = useTheme();

    const { user, setUser } = useContext(UserContext);


    const location = useLocation();
    const navigate = useNavigate();

    const query = new URLSearchParams(location.search);
    const selectionType = query.get("type") || "announcement";

    const { messages, setMessages } = useContext(MessageContext);

    const [type, setType] = useState({
        "representation": false,
        "virtualRepresentation": false,
        "endDateTime": false,
        "endDate": false,
        "timeOnly": false
    });
    const [loading, setLoading] = useState(false);
    const [withRep, setWithRep] = useState(false);
    const [withoutRep, setWithoutRep] = useState(false);
    const [officeRep, setOfficeRep] = useState(false);
    const [displayStepTwo, setDisplayStepTwo] = useState(false);
    const [timeOnly, setTimeOnly] = useState(false);
    const [endDate, setEndDate] = useState(false);
    const [endDateTime, setEndDateTime] = useState(false);
    const [noEnd, setNoEnd] = useState(false);

    const { t } = useTranslation();

    const attemptMessages = useRef(true);
    const drawerRef = useRef();

    const axiosInstance = useAxios();

    const fetchUser = async () => {
        await axiosInstance.current.get("/user").then(res => {
            if (res.status === 202) {
                setUser({
                    "userID": "account-not-active",
                    "mobilboxPassword": "****",
                    "surName": t("inactive"),
                    "familyName": t("user"),
                    ...user
                })
            } else {
                setUser({
                    ...res.data,
                    "vpnNumber": res.data.vpnNumber || "",
                    // calendarEntries: [
                    //     {
                    //         "id": "2152406",
                    //         "announcementName": "Office Vertretung mit Rückkehrdatum",
                    //         "optionalDisplayName": "Sommerurlaub",
                    //         "companyMessageUid": 343,
                    //         "startDate": "2024-05-17T22:00:00Z",
                    //         "endDate": "2024-06-03T22:00:00Z",
                    //         "notificationType": 0,
                    //         "repeatType": 0
                    //     }
                    // ]
                });
            }
        }).catch(err => {
            if (err.response) {
                console.log("user err: ", err.response)
            }
        })
    };

    useEffect(() => {
        document.title = t("vmm-select");
        document.body.style.backgroundColor = theme.palette.background.default;
        sessionStorage.removeItem("redirect");
        sessionStorage.setItem("displayContent", true);
        //eslint-disable-next-line
        if (user.userID === undefined) {
            fetchUser();
        }
        if (messages?.length === 0 && attemptMessages.current) {
            fetchMessages();
        }
        if (messages.length > 0) {
            setWithRep(false);
            setWithoutRep(false);
            setOfficeRep(false);
            setTimeOnly(false);
            setEndDate(false);
            setEndDateTime(false);
            setNoEnd(false);
            for (let i = 0; i < messages.length; i++) {
                //with representation
                if (messages[i]?.proxyMandatory && !messages[i]?.virtualRepresentation) {
                    setWithRep(true);
                }
                //with office representation
                if (!messages[i]?.proxyMandatory && messages[i]?.virtualRepresentation) {
                    setOfficeRep(true);
                }
                //without representation
                if (!messages[i]?.proxyMandatory && !messages[i]?.virtualRepresentation) {
                    setWithoutRep(true);
                }
                //timeOnly (Meeting)
                if (messages[i]?.timeOnlyMandatory &&
                    !messages[i]?.endDateMandatory &&
                    !messages[i]?.endDateTimeMandatory &&
                    messages[i]?.proxyMandatory === type?.representation &&
                    messages[i]?.virtualRepresentation === type?.virtualRepresentation
                ) {
                    setTimeOnly(true);
                }
                //endDate range
                if (!messages[i]?.timeOnlyMandatory &&
                    messages[i]?.endDateMandatory &&
                    !messages[i]?.endDateTimeMandatory &&
                    messages[i]?.proxyMandatory === type?.representation
                    && messages[i]?.virtualRepresentation === type?.virtualRepresentation
                ) {
                    setEndDate(true);
                }
                //endDateTime range
                if (!messages[i]?.timeOnlyMandatory &&
                    !messages[i]?.endDateMandatory &&
                    messages[i]?.endDateTimeMandatory &&
                    messages[i]?.proxyMandatory === type?.representation &&
                    messages[i]?.virtualRepresentation === type?.virtualRepresentation
                ) {
                    setEndDateTime(true);
                }
                //no end
                if (!messages[i]?.timeOnlyMandatory &&
                    !messages[i]?.endDateMandatory &&
                    !messages[i]?.endDateTimeMandatory &&
                    messages[i]?.proxyMandatory === type?.representation &&
                    messages[i]?.virtualRepresentation === type?.virtualRepresentation
                ) {
                    setNoEnd(true);
                }
            }
        }
        //eslint-disable-next-line
    }, [messages, type.representation, type.virtualRepresentation, theme.palette.mode]);

    const fetchMessages = async () => {
        setLoading(true);
        console.log("fetching messages from mobile selection");
        console.log("user: ", user);
        await axiosInstance.current.get("/messages?email=" + encodeURIComponent(user?.email)).then(res => {
            if (res.data?.length > 0) {
                setMessages(res.data);
                attemptMessages.current = false;
            } else {
                attemptMessages.current = false;
            }
        });
        setLoading(false);
    };

    const StepOne = () => {
        return (
            <Fragment>
                <Grid container sx={{ pl: 1, mt: 1.5 }}>
                    <IconButton onClick={() => (navigate("/dashboard"))} >
                        <ArrowBackIosNewIcon sx={{ color: "primary.main" }} />
                    </IconButton>
                    <Typography sx={{ fontSize: "20px", fontStyle: "normal", fontWeight: 600, lineHeight: "28px", letterSpacing: "-0.3px", mt: .5, ml: .5 }}>{t("choose-representation")}</Typography>
                </Grid>
                <Box sx={{ px: 2, mt: 2 }}>
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={() => {
                            setType({
                                ...type,
                                representation: true,
                                virtualRepresentation: false
                            });
                            setDisplayStepTwo(true);
                        }}
                        startIcon={<PersonIcon />}
                        endIcon={<ForwardIcon sx={{ fontSize: 32 }} />}
                        disableElevation
                        sx={{
                            borderRadius: "10px",
                            textTransform: "none",
                            height: "64px",
                            display: withRep ? "flex" : "none"
                        }}
                    >
                        <Typography
                            noWrap
                            sx={{
                                overflow: "hidden",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "20px"
                            }}
                        >
                            {t("with-representation")}
                        </Typography>
                        <Box key="spacer" sx={{ flexGrow: 1 }} />
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={() => {
                            setType({
                                ...type,
                                representation: false,
                                virtualRepresentation: false
                            })
                            setDisplayStepTwo(true);
                        }}
                        startIcon={<PersonOutlinedIcon />}
                        endIcon={<ForwardIcon sx={{ fontSize: 32 }} />}
                        disableElevation
                        sx={{
                            mt: 1,
                            borderRadius: "10px",
                            textTransform: "none",
                            height: "64px",
                            display: withoutRep ? "flex" : "none"
                        }}
                    >
                        <Typography
                            noWrap
                            sx={{
                                overflow: "hidden",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "20px"
                            }}
                        >
                            {t("without-representation")}
                        </Typography>
                        <Box key="spacer" sx={{ flexGrow: 1 }} />
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={() => {
                            setType({
                                ...type,
                                representation: false,
                                virtualRepresentation: true
                            });
                            setDisplayStepTwo(true);
                        }}
                        startIcon={<OfficeIcon />}
                        endIcon={<ForwardIcon sx={{ fontSize: 32 }} />}
                        disableElevation
                        sx={{
                            mt: 1,
                            borderRadius: "10px",
                            textTransform: "none",
                            height: "64px",
                            display: officeRep ? "flex" : "none"
                        }}
                    >
                        <Typography
                            noWrap
                            sx={{
                                overflow: "hidden",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "20px"
                            }}
                        >
                            {t("office-representation")}
                        </Typography>
                        <Box key="spacer" sx={{ flexGrow: 1 }} />
                    </Button>
                </Box>
            </Fragment>
        );
    }

    const StepTwo = () => {
        return (
            <Fragment>
                <Grid container sx={{ pl: 1, mt: 1.5 }}>
                    <IconButton onClick={() => { setDisplayStepTwo(false); setType({ representation: false, virtualRepresentation: false, endDate: false, endDateTime: false, timeOnly: false }) }} >
                        <ArrowBackIosNewIcon sx={{ color: "primary.main" }} />
                    </IconButton>
                    <Typography sx={{ fontSize: "20px", fontStyle: "normal", fontWeight: 600, lineHeight: "28px", letterSpacing: "-0.3px", mt: .5, ml: .5 }}>{t("choose-announcement")}</Typography>
                </Grid>
                <Box sx={{ px: 2, mt: 2 }}>
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={() => {
                            const newType = {
                                ...type,
                                timeOnly: true,
                                endDate: false,
                                endDateTime: false
                            };
                            setType(newType);
                            drawerRef.current.open(newType, selectionType);
                        }}
                        startIcon={<TimeIcon />}
                        endIcon={<ForwardIcon sx={{ fontSize: 32 }} />}
                        disableElevation
                        sx={{
                            borderRadius: "10px",
                            textTransform: "none",
                            height: "64px",
                            display: timeOnly ? "flex" : "none"
                        }}
                    >
                        <Typography
                            noWrap
                            sx={{
                                overflow: "hidden",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "20px"
                            }}
                        >
                            {t("time-announcement")}
                        </Typography>
                        <Box key="spacer" sx={{ flexGrow: 1 }} />
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={() => {
                            const newType = {
                                ...type,
                                timeOnly: false,
                                endDate: true,
                                endDateTime: false
                            };
                            setType(newType);
                            drawerRef.current.open(newType, selectionType);
                        }}
                        startIcon={<CalendarIcon />}
                        endIcon={<ForwardIcon sx={{ fontSize: 32 }} />}
                        disableElevation
                        sx={{
                            mt: 1,
                            borderRadius: "10px",
                            textTransform: "none",
                            height: "64px",
                            display: endDate ? "flex" : "none"
                        }}
                    >
                        <Typography
                            noWrap
                            sx={{
                                overflow: "hidden",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "20px"
                            }}
                        >
                            {t("date-announcement")}
                        </Typography>
                        <Box key="spacer" sx={{ flexGrow: 1 }} />
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={() => {
                            const newType = {
                                ...type,
                                timeOnly: false,
                                endDate: false,
                                endDateTime: true
                            };
                            setType(newType);
                            drawerRef.current.open(newType, selectionType);
                        }}
                        startIcon={<DateTimeIcon />}
                        endIcon={<ForwardIcon sx={{ fontSize: 32 }} />}
                        disableElevation
                        sx={{
                            mt: 1,
                            borderRadius: "10px",
                            textTransform: "none",
                            height: "64px",
                            display: endDateTime ? "flex" : "none"
                        }}
                    >
                        <Typography
                            noWrap
                            sx={{
                                overflow: "hidden",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "20px"
                            }}
                        >
                            {t("datetime-announcement")}
                        </Typography>
                        <Box key="spacer" sx={{ flexGrow: 1 }} />
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={() => {
                            const newType = {
                                ...type,
                                timeOnly: false,
                                endDate: false,
                                endDateTime: false
                            };
                            setType(newType);
                            drawerRef.current.open(newType, selectionType);
                        }}
                        startIcon={<CalendarNoEndIcon />}
                        endIcon={<ForwardIcon sx={{ fontSize: 32 }} />}
                        disableElevation
                        sx={{
                            mt: 1,
                            borderRadius: "10px",
                            textTransform: "none",
                            height: "64px",
                            display: noEnd ? "flex" : "none"
                        }}
                    >
                        <Typography
                            noWrap
                            sx={{
                                overflow: "hidden",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "20px"
                            }}
                        >
                            {t("without-enddate")}
                        </Typography>
                        <Box key="spacer" sx={{ flexGrow: 1 }} />
                    </Button>
                </Box>
            </Fragment>
        );
    };

    return (
        <Fragment>
            <Typography sx={{ ml: 2, mt: -3, fontSize: "30px", fontStyle: "normal", fontWeight: 700, lineHeight: "34px", letterSpacing: "-0.75px", position: "relative", zIndex: theme.zIndex.appBar + 101 }}>{selectionType === "favourite" ? t("new-favorite") : t("new-voicemail")}</Typography>
            {displayStepTwo ?
                <StepTwo /> :
                <StepOne />
            }
            <Backdrop
                sx={{
                    zIndex: (theme) => Math.max.apply(Math, Object.values(theme.zIndex)) + 1,
                }}
                open={loading}
            >
                <CircularProgress
                    size={108}
                    thickness={2}
                    sx={{ color: "#fff" }}
                />
            </Backdrop>
            <DashboardDrawer ref={drawerRef} />
        </Fragment>
    );
};